export enum BrowserTabsMessageType {
  Hello = 'hello',
  State = 'state',
  Bye = 'bye',
}
